module.exports = __webpack_public_path__ + "static/media/benefit_placeholder_3.24b78dcd.png";